import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../shared/component/header/header.module';
import { LoadingSpinnerModule } from '../shared/design-system/loading-spinner/loading-spinner.module';
import { EventCardModule } from '../shared/component/event-card/event-card.module';



@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    RouterModule,
    HeaderModule,
    LoadingSpinnerModule,
    EventCardModule
  ]
})
export class HomeModule { }
